import { render, staticRenderFns } from "./assignTransporter.vue?vue&type=template&id=f3ba4156&scoped=true&"
import script from "./assignTransporter.vue?vue&type=script&lang=js&"
export * from "./assignTransporter.vue?vue&type=script&lang=js&"
import style0 from "./assignTransporter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./assignTransporter.vue?vue&type=style&index=1&id=f3ba4156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ba4156",
  null
  
)

export default component.exports